import { render } from "./통역서비스.vue?vue&type=template&id=63de5a7d"
import script from "./통역서비스.vue?vue&type=script&lang=js"
export * from "./통역서비스.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__